export default __webpack_public_path__ + "static/media/gmail-icon.8aeaad8a.svg";